export default "__VITE_ASSET__7hn7qA1T__"